type Params = {
    valueMin: number;
    valueMax: number;
    controlMin: number;
    controlMax: number;
    changedField: "value_min" | "value_max";
};

export const validateRangeFilter = (
    {
        valueMin,
        valueMax,
        controlMin,
        controlMax,
        changedField,
    }: Params
) => {
    let nextMin = valueMin;
    let nextMax = valueMax;

    if (changedField === "value_min") {
        const maxLimit =
            valueMax !== controlMax
                ? Math.min(valueMax, controlMax)
                : controlMax;

        nextMin = Math.max(
            controlMin,
            Math.min(valueMin, maxLimit),
        );
    }

    if (changedField === "value_max") {
        const minLimit =
            valueMin !== controlMin
                ? Math.max(valueMin, controlMin)
                : controlMin;

        nextMax = Math.min(
            controlMax,
            Math.max(valueMax, minLimit),
        );
    }

    return {
        value_min: nextMin,
        value_max: nextMax,
    };
};
